export default {
  init() {

    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      // Do something
      if(scroll > 200) {
        $('header').addClass('bg');
      } else {
        $('header').removeClass('bg');
      }
  });


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    /*$('.slides').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      arrows: false,
      autoplay: true,
    });*/

    $('.gallery-slides').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      arrows: false,
      autoplay: false,
    });

    $('.gallery-slider-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.gallery-slides',
      dots: false,
      focusOnSelect: true,
      arrows: false,
      infinite: false,
    });
    $.fn.selectpicker.Constructor.BootstrapVersion = '4';
    $('.szobaszam').selectpicker();
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/common.js